import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MecordColors } from "Constants/Color";

interface CancelBackButtonProps {
  to?: string | number; // Route path or -1 for back navigation
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
}

const CancelBackButton: React.FC<CancelBackButtonProps> = ({
  to = -1,
  disabled = false,
  onClick,
  label = "Cancel",
}) => {
  const navigate = useNavigate();
  const [hovering, setHovering] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    } else if (typeof to === "number" && to === -1) {
      navigate(-1);
    } else if (typeof to === "string") {
      navigate(to);
    }
  };

  return (
    <Button
      variant="link"
      className="px-3 px-md-4"
      style={{
        backgroundColor: hovering ? "#FFE5E5" : MecordColors.LightThemeBGColor,
        color: MecordColors.ActiveText,
        textDecoration: "none",
        border: `1px solid ${MecordColors.ActiveText}`,
        transition: "background-color 0.15s ease-in-out"
      }}
      onClick={handleClick}
      disabled={disabled}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      {label}
    </Button>
  );
};

export default CancelBackButton;


